export enum ServerModuleType {
  ADVANCED_HISTORY = 'ADVANCED_HISTORY',
  WEATHER = 'WEATHER',
  SWITCHES = 'SWITCHES',
}
